export default __webpack_public_path__ + "static/media/Group 17146.fa685e44.svg";